import { apiSlice } from '../api/apiSlice';

export const notificationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: ({ userId, limit = 50, skip = 0 }) => ({
        url: `/notification/mine?userId=${userId}&limit=${limit}&skip=${skip}`,
      }),
      providesTags: ['Notifications'],
    }),
    deleteNotification: builder.mutation({
      query: ({ id, userId }) => ({
        url: `/notification/${id}?userId=${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),
    clearNotifications: builder.mutation({
      query: ({ userId }) => ({
        url: `/notification/user/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useDeleteNotificationMutation,
  useClearNotificationsMutation,
} = notificationApiSlice;
